<template>
    <v-container>
        <h1>Liste des particularités</h1>
        <v-btn
            class="mb-3 mr-3"
            color="secondary"
            @click="generatePDF()"
        >
            <v-icon left>  
            mdi-file-pdf-box
            </v-icon>
            Télécharger en PDF
        </v-btn>

<v-card >
            <v-card-title>
                Filtres
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col
                    cols="12"
                    md="2"
                    >
                        <v-menu
                            ref="menuBegin"
                            :close-on-content-click="false"
                            :return-value.sync="filters.begindate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="momentFormattedBegin"
                                clearable
                                prepend-icon="mdi-calendar"
                                label="Date de début"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="filters.begindate = null; datealert = null;"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.begindate"
                                no-title
                                scrollable
                                locale="fr"
                                @change="onDateChange"
                            >
                            <v-spacer></v-spacer>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                    cols="12"
                    md="2"
                    >
                        <v-menu
                            ref="menuEnd"
                            :close-on-content-click="false"
                            :return-value.sync="filters.enddate"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                :value="momentFormattedEnd"
                                clearable
                                label="Date de fin"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                @click:clear="filters.enddate = null; datealert = null;"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="filters.enddate"
                                no-title
                                scrollable
                                locale="fr"
                                @change="onDateChange"
                            >
                            <v-spacer></v-spacer>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col
                    cols="12"
                    md="2"
                    >
                        <v-combobox 
                            label="Site"
                            :items="sites" 
                            clearable
                            item-value="id" 
                            item-text="nom" 
                            v-model="siteCmb" 
                            @change="updateSite"
                            @click:clear="filters.site = undefined; siteCmb = undefined;">
                        </v-combobox>
                    </v-col>
                </v-row>
                <v-alert v-if="datealert"
                    text
                    prominent
                    type="error"
                    >
                    La date de début doit être inférieure à la date de fin
                </v-alert>
            </v-card-text>
        </v-card>


        <v-data-table
            locale="fr"
            :headers="fields"
            :items="filteredParticularites"
            :items-per-page="10"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="elevation-1"
            :loading="loading"
            loading-text="Chargement..."
        >
        <template v-slot:item.date="{ item }">
            {{utils.toPrettyDate(item.date)}}
        </template>
        <template v-slot:item.sites="{item}"><v-chip color="primary" v-for="site of item.sites" :key="site">{{sitesById[site].nom}}</v-chip></template>  
        <template v-slot:item.titre="{item}"><h3>{{item.titre}}</h3></template>  
        </v-data-table>
    </v-container>
</template>

<script>
import api from "@/api";
import utils from "@/utils";
import moment from "moment";
import store from "@/store";
export default {
  data() {
    return {
      utils,
      particularites: [],
      sites: [],
      siteCmb: undefined,
      sitesById: [],
      perPage: 10,
      currentPage: 1,
      sortBy: "date",
      sortDesc: false,
      fields: [
        { value: "date", text: "Date", sortable: true },
        { value: "sites", text: "Site(s)", sortable: true },
        { value: "titre", text: "Titre", sortable: false },
        { value: "contenu", text: "Contenu", sortable: false }
      ],
      filters: {
        begindate: null,
        enddate: null,
        site: undefined
      },
      datealert: false
    };
  },
  created() {
      this.loadData();
  },
  methods: {
      async loadData() {
        this.$store.commit("setLoading", true);
        this.sites = (await api.getSites()).data.sites;
        for (let site of this.sites) {
        this.sitesById[site.id] = site;
        }
        this.particularites = (await api.getParticularites()).data.particularites;
        this.$store.commit("setLoading", false);
      },
    updateSite(){
        if (this.siteCmb) this.filters.site = this.siteCmb.id;
    },
    onDateChange() {
        this.$refs.menuEnd.save(this.filters.enddate);
        this.$refs.menuBegin.save(this.filters.begindate);
      this.datealert =
        this.filters.begindate !== null &&
        this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, 'day');
    },
    generatePDF() {
      api.pdf(`particularites`, { filters: this.filters }, `particularites`);
    }
  },
  computed: {
    loading() {
    return store.state.loading;
    },
    momentFormattedBegin() {
        return this.filters.begindate ? this.utils.toPrettyDate(this.filters.begindate) : '';
    },
    momentFormattedEnd(){
        return this.filters.enddate ? this.utils.toPrettyDate(this.filters.enddate) : '';
    },
    filteredParticularites() {
      return this.particularites.filter(particularite => {
        let ok = true;
        if (ok && this.filters.site !== undefined) {
          if (particularite.sites.indexOf(this.filters.site) === -1) {
            ok = false;
          }
        }
        if (ok && this.filters.begindate !== null) {
          if (moment(particularite.date).isBefore(this.filters.begindate, 'day')) {
            ok = false;
          }
        }
        if (ok && this.filters.enddate !== null) {
          if (moment(particularite.date).isAfter(this.filters.enddate, 'day')) {
            ok = false;
          }
        }
        return ok;
      });
    }
  }
};
</script>